"use client";
import React, { useState } from "react";
import HeroVideo2_Layout1 from "./HeroVideo2-Layouts/Layout1";
import HeroVideo2_Layout2 from "./HeroVideo2-Layouts/Layout2";
import HeroVideo2_Layout3 from "./HeroVideo2-Layouts/Layout3";
import HeroVideo2_Layout4 from "./HeroVideo2-Layouts/Layout4";
import HeroVideo2_Layout5 from "./HeroVideo2-Layouts/Layout5";

interface VideoPlayerProps {
  videoSource: string;
  title: string;
  description: string;
  btnLabel: string;
  btnLink: string;
}
interface HeroVideo2Props {
  data: {
    title: string;
    subtitle: string;
    btnLink: string;
    btnText: string;
    videos: VideoPlayerProps[];
    isLive: boolean;
  };
}

export default function HeroVideo2({ data }: HeroVideo2Props) {
  const [selectedLayout, setSelectedLayout] = useState("layout5");

  if (!data.isLive) return null;

  const renderLayout = () => {
    switch (selectedLayout) {
      case "layout1":
        return <HeroVideo2_Layout1 data={data} />;
      case "layout2":
        return <HeroVideo2_Layout2 data={data} />;
      case "layout3":
        return <HeroVideo2_Layout3 data={data} />;
      case "layout4":
        return <HeroVideo2_Layout4 data={data} />;
      case "layout5":
        return <HeroVideo2_Layout5 data={data} />;
      default:
        return <HeroVideo2_Layout1 data={data} />;
    }
  };

  return (
    <>
      <HeroVideo2_Layout5 data={data} />;
    </>
  );
}
